<template>
  <div class="wrap-withdraw">
    <div class="main-content">
        <face-recognition/>
      </div>
  </div>
</template>

<script>
import FaceRecognition from '../FaceRecognition.vue';
export default {
  components: {FaceRecognition },
  data() {
    return {
      typeWithdraw: "offexchange",
      currentPage: 1,
      perPage: 10,
      owner: "",
      startDate: "",
      endDate: "",
      status: "",
      serialNumber: "",
      activity: "withdrawal",
      hallmark: "",
      dateType: "",
      contract_id: "",
      badgeValue: 7,
      typePage: "history",
    };
  },
  mounted() {
    this.getData(
      this.currentPage,
      this.perPage,
      this.typeWithdraw,
      this.owner,
      this.startDate,
      this.endDate,
      this.status,
      this.serialNumber
    );
  },
  methods: {
    getData(
      currentPage,
      perPage,
      type,
      owner,
      startDate,
      endDate,
      status,
      serialNumber
    ) {
      this.$store.dispatch("getWithdraw", {
        currentPage: currentPage,
        perPage: perPage,
        type: type,
        owner: owner,
        startDate: startDate,
        endDate: endDate,
        status: status,
        serialNumber: serialNumber,
      });
    },
    tabOnClick(value) {
      this.typePage = value;
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.getData(
        this.currentPage,
        this.perPage,
        this.typeWithdraw,
        this.owner,
        this.startDate,
        this.endDate,
        this.status,
        this.serialNumber
      );
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
  computed: {
    getWithdrawData() {
      return this.$store.state.vaultModul.withdrawData;
    },
    getTotalData() {
      return this.$store.state.vaultModul.totalData;
    },
  },
};
</script>

<style scoped>
.title-page {
  font-size: 25px;
  font-weight: bold;
  margin-bottom: 40px;
}
.nav-tab {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 2rem;
  color: #636366;
  padding: 1rem 0;
  justify-self: flex-start;
}

.tab {
  padding: 0.8rem 1rem;
  cursor: pointer;
}

.tab:hover,
.activeTab {
  color: var(--clr-scondary);
  border-bottom: 2px solid var(--clr-scondary);
}

.img-margin {
  margin-left: 2em;
}

.badge-container {
  display: inline-block;
  position: relative;
}

.badge {
  background-color: #0a0a0a;
  color: #fff;
  font-size: 11px;
  padding: 4px 7px;
  border-radius: 100%;
}

#app {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
